import React from 'react'
import { Table } from '../../../components/ui/Table'
import { updateStatusString } from '../../../constants/update_status'
import { format } from 'date-fns'
import { updateReportAdTypeString } from '../../../config'
import { LoadFunc, useTableHooks } from '../../../packages/blueprint-components/src/useTableHooks'
import { useRecoilValue } from 'recoil'
import { unsuccessfulReports } from './update_details_state'
import Report = Models.Report
import { Column } from '../../../types/table'

export const UnsuccessfulReports = () => {
    const items = useRecoilValue(unsuccessfulReports)

    const load: LoadFunc<Report> = () =>
        Promise.resolve({
            data: { data: [] },
        })
    const tableHooks = useTableHooks(load)
    tableHooks.items = items ?? []

    const columns: Column<Report, any>[] = [
        {
            key: 'id',
            title: 'Report Id',
        },
        { key: 'report_id' },
        {
            key: 'status_id',
            title: 'Status',
            cell: (row: Report) => {
                return (
                    <span className="whitespace-nowrap">{updateStatusString(row.status_id)}</span>
                )
            },
        },
        {
            key: 'type',
            cell: ({ type }: Report) => updateReportAdTypeString(type),
        },
        { key: 'start_date' },
        { key: 'end_date' },
        { key: 'date' },
        {
            key: 'created_at',
            cell: (row: Report) => {
                return (
                    <span className="whitespace-nowrap">
                        {format(new Date(row.created_at), 'M/d/yy H:mm a')}
                    </span>
                )
            },
        },
        {
            key: 'updated_at',
            cell: (row: Report) => {
                return (
                    <span className="whitespace-nowrap">
                        {format(new Date(row.updated_at), 'M/d/yy H:mm a')}
                    </span>
                )
            },
        },
    ]

    console.log('items', tableHooks.items)

    return (
        <Table
            name="Unsuccessful Reports"
            showHeader
            className="w-full"
            filters={null}
            canSelect={false}
            columnSelection={false}
            columns={columns}
            tableHooks={tableHooks}
            onSelectChange={null}
            height={300}
        />
    )
}
